// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  ApplicationGatewayWafDynamicManifestResult,
  ApplicationGatewayWafDynamicManifestsGetOptionalParams,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a ApplicationGatewayWafDynamicManifests. */
export interface ApplicationGatewayWafDynamicManifests {
  /**
   * Gets the regional application gateway waf manifest.
   * @param location The region where the nrp are located at.
   * @param options The options parameters.
   */
  list(
    location: string,
    options?: ApplicationGatewayWafDynamicManifestsGetOptionalParams,
  ): PagedAsyncIterableIterator<ApplicationGatewayWafDynamicManifestResult>;
}
